module.exports = __webpack_public_path__ + "img/icon_5_39.09edea7a.png";